import styled from 'styled-components';

export const MessageWrapper = styled.div`
  padding: 5px 10px;
  border-radius: 4px;
  &:hover {
    background: #ced9e0;
  }
`;
